import OtDocumentsIndex from '@/areas/documents/ot-documents-index.vue';
import OtDocumentsLayout from '@/areas/documents/ot-documents-layout.vue';
import OtGlobalDocumentLayout from '@/areas/documents/ot-global-document-layout.vue';
import OtDocumentAssociations from '@/components/documents/document-associations/ot-document-associations-list.vue';
import OtDocumentDetails from '@/components/documents/document-details/ot-document-details.vue';
import { BreadcrumbsId } from '@/components/global/common-models';
import { RouteConfig } from 'vue-router';

export const ROUTE_GLOBAL_DOCUMENTS = 'GlobalDocuments';
export const ROUTE_GLOBAL_DOCUMENT = 'GlobalDocument';
export const ROUTE_GLOBAL_DOCUMENT_ASSOCIATIONS = 'GlobalDocumentAssociations';

export const documentsRoutes: Array<RouteConfig> = [
  {
    path: '/documents',
    component: OtDocumentsLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: ROUTE_GLOBAL_DOCUMENTS,
        component: OtDocumentsIndex,
        meta: {
          breadcrumb: 'Documents',
        },
      },
    ],
  },
  {
    path: '/documents/:documentGid',
    component: OtGlobalDocumentLayout,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: '/',
        name: ROUTE_GLOBAL_DOCUMENT,
        // Yes, this is not org specific, it's a shared document component
        component: OtDocumentDetails,
        meta: {
          breadcrumb: `Documents/${BreadcrumbsId.DocumentId}`,
        },
      },
      {
        path: 'associations',
        name: ROUTE_GLOBAL_DOCUMENT_ASSOCIATIONS,
        // Yes, this is not org specific, it's a shared document component
        component: OtDocumentAssociations,
        meta: {
          breadcrumb: `Documents/${BreadcrumbsId.DocumentId}/associations`,
        },
      },
    ],
  },
];
